import React, { memo } from "react";
import PropTypes from "prop-types";
import { RelatoriosDataGrid } from "../../organisms";
import { PageTemplate } from "../";

const ReportsTemplate = memo((props) => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}
    >
      <RelatoriosDataGrid
        key={crypto.randomUUID()}
        {...restDataGridProps}
        initialState={{
          ...initialState,
          density: "comfortable",
        }}
        state={state}
      />
    </PageTemplate>
  );
});

ReportsTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dataGridProps: PropTypes.object,
};

export default ReportsTemplate;
